/* eslint-disable no-shadow */
export enum PlatformEnum {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}
/* eslint-enable no-shadow */
